import { defineStore } from 'pinia'
import { ref, computed, watch } from 'vue'
import { darkTheme, lightTheme } from 'naive-ui'

export const useThemeStore = defineStore('theme', () => {
  const isDark = ref(true) // 默认设置为暗色主题

  const theme = computed(() => isDark.value ? darkTheme : lightTheme)

  // 设置HTML的data-theme属性
  const setHtmlTheme = (dark: boolean) => {
    const html = document.documentElement
    if (dark) {
      html.setAttribute('data-theme', 'dark')
    } else {
      html.setAttribute('data-theme', 'light')
    }
  }

  const toggleTheme = () => {
    isDark.value = !isDark.value
    setHtmlTheme(isDark.value)
  }

  const setTheme = (dark: boolean) => {
    isDark.value = dark
    setHtmlTheme(dark)
  }

  // 初始化主题
  const initTheme = () => {
    setHtmlTheme(isDark.value)
  }

  // 监听主题变化
  watch(isDark, (newValue) => {
    setHtmlTheme(newValue)
  })

  return {
    isDark,
    theme,
    toggleTheme,
    setTheme,
    initTheme
  }
}) 